import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Admin.css';
import TabPanel from '../TabPanel/TabPanel';
import Panel from '../TabPanel/Panel';
import OrgManagement from '../OrgManagement/OrgManagement';
import UserGroupManagement from '../UserGroupManagement/UserGroupManagement';
import ModuleManagement from '../ModuleManagement/ModuleManagement';
import { userCanVisitRoute, getDefaultRouteForUser, getStateFromRoute } from '../../common/adminPermissions';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function Admin() {
  const environmentContext = useContext(EnvironmentContext);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPanel, setCurrentPanel] = useState('');
  const [currentSubPanel, setCurrentSubPanel] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const { activeUser: user } = environmentContext;

  if (logComponent('Admin')) {console.debug('Admin render'); }

  useEffect(() => {
    if (logComponent('Admin')) {console.debug('Admin onMount'); }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
      checkRoute();
  }, []);

  useEffect(() => {
    if (logComponent('Admin')) {console.debug('Admin useEffect [location.pathname]'); }
    checkRoute();

  }, [location.pathname])


  const checkRoute = () => {
    if (logComponent('Admin')) {console.debug('Admin checkRoute'); }

    if (location.pathname === '/admin' || 
      !userCanVisitRoute(user, location.pathname)) {
      navigate(getDefaultRouteForUser(user), { replace: true });
    } else {
      const newState = getStateFromRoute(location.pathname);
      setIsLoading(false);
      setCurrentPanel(newState.currentPanel);
      setCurrentSubPanel(newState.currentSubPanel);
    }    
  }


  return (
    <div className="Admin">
      {
        !isLoading ?
        <React.Fragment>
        <h2 className="Admin__heading">Administrative Settings</h2>
        { 
          currentSubPanel && currentSubPanel.longTitle &&
          <h3 className="Admin__sub-heading">{ currentSubPanel.longTitle }</h3>
        }
        <TabPanel 
          className="Admin__tab-panel"
          currentPanel={currentPanel}>  
          <Panel 
            title="Organizations"
            linkPath="/admin/facilities"
            hideIf={!user || user.groupTypeString !=='Status Solutions'}>
            <OrgManagement 
              currentPanel={currentSubPanel} />
          </Panel>
          <Panel 
            title="Modules"
            linkPath="/admin/modules"
            hideIf={ !user || user.groupTypeString === 'Family'|| !user.isAdmin }>
            <ModuleManagement />
          </Panel>
          <Panel 
            title="Users &amp; Groups"
            linkPath="/admin/users"
            hideIf={ !user || !user.isAdmin }>
            <UserGroupManagement currentSubPanel={currentSubPanel} />
          </Panel>
        </TabPanel>
        </React.Fragment> :
        <div className="Admin__loading">
        Loading Admin page...
        </div>
      }
    </div>
  );
}